import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'

const isInteger = (value?: string | number) => {
  if (Number.isInteger) {
    return Number.isInteger(value)
  }

  return typeof value === 'number' && Number.isFinite(value) && Math.floor(value) === value
}

const isValidNumberFromMixed = (n: null | void | string | number) => {
  const parsed = Number(n)

  if (isNil(n) || (typeof n !== 'number' && isEmpty(n))) {
    return false
  }

  if (typeof n !== 'number' && typeof n !== 'string') {
    return false
  }

  return !Number.isNaN(parsed) && Number.isFinite(parsed)
}

const toNumber = (value?: string | number): number | null => {
  if (!isValidNumberFromMixed(value)) {
    return null
  }

  return parseFloat(String(value))
}

export default {
  isInteger,
  isValidNumberFromMixed,
  toNumber
}
